import { useTranslations } from 'use-intl';
import { useFormatters } from '@financialharmony/ui';
import { formatTaxNextCheck, formatTaxSyncedAt } from '@financialharmony/ui/tax/rowModel';

/**
 * The line under a "no skattekonto yet" account: when the authority was last asked and when the
 * schedule asks next, in Stockholm time and the language the app shows. Says only what is known;
 * null when neither is, so an unknown time is never invented.
 */
export function useTaxNoAccountDetail() {
  const t = useTranslations('tax.noAccount');
  const { locale } = useFormatters();
  return (
    account: { lastCheckedAt?: string | null; nextCheckAt?: string | null },
    now: Date = new Date(),
  ): string | null => {
    const last = account.lastCheckedAt ? formatTaxSyncedAt(account.lastCheckedAt, now, locale) : null;
    const next = account.nextCheckAt ? formatTaxNextCheck(account.nextCheckAt, now, locale) : null;
    if (last && next) return t('detail', { last, next });
    if (last) return t('detailLastOnly', { last });
    if (next) return t('detailNextOnly', { next });
    return null;
  };
}
